import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '../../../shared/components/ui/modal/modal.component';
import { CommonModule } from '@angular/common';
import { FolderApiService } from '../services/folder-api.service';
import { SegmentFolder, SegmentFolderRequest } from '../models/segment.model';
import { ToastService } from '../../../shared/services/toast.service';
import { ButtonComponent } from '../../../shared/components/ui/button/button.component';
import { AlertComponent } from '../../../shared/components/ui/alert/alert.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-folder-form-modal',
  standalone: true,
  imports: [
    ModalComponent,
    ReactiveFormsModule,
    CommonModule,
    ButtonComponent,
    AlertComponent
  ],
  templateUrl: './folder-form-modal.component.html',
})
export class FolderFormModalComponent implements OnInit, OnChanges, OnDestroy {

  @Input() isOpen: boolean = false;
  @Input() bussinesId!: number;
  @Output() close = new EventEmitter<boolean>();
  @Output() folderCreated = new EventEmitter<SegmentFolder>();


  folderForm!: FormGroup;
  isSaving: boolean = false;
  errorMessage = '';
  submitted: boolean = false;

  private $destroy = new Subject<void>();


  constructor(
    private fb: FormBuilder,
    private folderApi: FolderApiService,
    private toast: ToastService,
  ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      // El modal acaba de aparecer en pantalla. Limpiamos variables y el formulario.
      this.submitted = false;
      this.isSaving = false;
      this.errorMessage = '';

      if (this.folderForm) {
        this.folderForm.reset({ name: '' });
      }
    }
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  private initializeForm(): void {
    this.folderForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]]
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.folderForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched || this.submitted));
  }

  onClose() {
    this.folderForm.reset();
    this.errorMessage = '';
    this.close.emit(false);
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.folderForm.invalid) {
      this.folderForm.markAllAsTouched();
      return;
    }

    if (!this.bussinesId || this.bussinesId <= 0) {
      this.errorMessage = 'Error: ID de negocio inválido. Por favor recarga la página';
      this.isSaving = false;
      return;
    }

    this.isSaving = true;
    this.errorMessage = '';

    const request: SegmentFolderRequest = {
      bussinesId: this.bussinesId,
      name: this.folderForm.value.name.trim()
    };


    this.folderApi.createFolder(request)
      .pipe(takeUntil(this.$destroy))
      .subscribe({
        next: (nuevaCarpeta: SegmentFolder) => {
          this.isSaving = false;
          this.folderCreated.emit(nuevaCarpeta);
          this.toast.success({ title: 'Carpeta creada', message: `"${nuevaCarpeta.name}" se creó correctamente.` });
          this.folderForm.reset();
          this.close.emit(true);
        },
        error: (err) => {
          this.isSaving = false;
          const errorMsg = err?.error?.message
            || err?.message
            || 'No se pudo crear la carpeta. Intenta de nuevo mas tarde';
          this.errorMessage = errorMsg;
        }
      });
  }




}
